// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2n1wT","selects":"Documents_selects__aktcX"};